export const TableChecklistHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: 'Splněno?',
                    type: 'custom-html',
                    className: 'column-sm',
                    key: 'status',
                    isVisible: true,
                    modifier: (value) => {
                        let StatusIcon = 'wrong';

                        if (value == '2') {
                            StatusIcon = 'perfect';
                        }

                        return `<div class="questionnaire-mark questionnaire-mark-${StatusIcon}"></div>`;
                    }
                },
                {
                    title: this.$t('onboarded_employee'),
                    type: 'custom-html',
                    key: 'candidate_id',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'light-silver';
                            let available_candidate = '';

                            if(this.options.filters.find(o => o.key === 'filter-with-candidate')){
                                available_candidate = this.options.filters.find(o => o.key === 'filter-with-candidate');
                            } else {
                                available_candidate = this.options.filters.find(o => o.key === 'filter-with-candidate');
                            }

                            let candidate_html = '';
                            for (var i in available_candidate.option) {
                                if(available_candidate.option[i].id == value){
                                    candidate_html += available_candidate.option[i].value;
                                }
                            }

                            return '<div>'+candidate_html+'</div>';
                        }
                    }
                },
                {
                    title: this.$t('deadline'),
                    type: 'custom-html',
                    className: 'column-sm',
                    key: 'deadline',
                    isVisible: true,
                    modifier: (date) => {

                        let addDate = new Date(date);
                        let todaysDate = new Date();
                        if(addDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
                            return '<b>'+this.$t('today')+'</b>';
                        } else if(addDate.setHours(0,0,0,0) > todaysDate.setHours(0,0,0,0)){
                            let formattedDate = moment(date).format('DD. MM. YYYY');
                            return formattedDate;
                        } else if(moment(date).isValid()){
                            let formattedDate = moment(date).format('DD. MM. YYYY');
                            return '<span class="warning-color">'+formattedDate+'</span>';
                        } else {
                            return "-"
                        }

                    }
                },
                
                {
                    title: this.$t('timeline'),
                    type: 'custom-html',
                    className: 'column-sm',
                    key: 'timeline_state',
                    isVisible: true,
                    modifier: (value) => {

                        let timelineState = '';

                        if(value <= 7){
                            timelineState = 'Před nástupem';
                        } else if(value = 8){
                            timelineState = 'První den';
                        } else if(value = 9){
                            timelineState = 'Zkušební doba';
                        } else if(value = 10){
                            timelineState = 'Zaměstnání';
                        } else if(value = 11){
                            timelineState = 'Povýšení';
                        } else if(value = 12){
                            timelineState = 'Mateřská';
                        } else if(value = 13){
                            timelineState = 'Offboarding';
                        }


                        return `${timelineState}`;
                    }
                },
                {
                    title: this.$t('tasks_internal'),
                    type: 'text',
                    key: 'name',

                },


            ],
            actionObj : {
                title: ' ',
                type: 'action',
            }
        }
    },
}
